import {Injectable} from '@angular/core';
import {Observable} from "rxjs";
import {MatDialog} from '@angular/material/dialog';
import {ComponentType} from '@angular/cdk/portal';
import {TranslateService} from '@ngx-translate/core';
import {CommonDialogService} from 'common-framework/shared-module';
import {FileUploadFormComponent} from '../file-upload-form/file-upload-form.component';

export interface FileUploadFormConfigs {
  uploadPath?: string,
  uploadParams?: any,
  dialogTitle?: string,
  downloadTemplateTitle?: string,
  downloadTemplatePlaceholder?: string,
  uploaderExtensions?: string,
  uploaderFileType?: string,
  uploaderFormControlName?: string,
  uploaderLabelInput?: string,
  uploaderShowProgress?: boolean,
  returnAsFile?: boolean,
  submitButtonLabel?: string,
  uploaderFileSize?: number,
}

@Injectable({
  providedIn: 'root'
})
export class DialogService extends CommonDialogService {

  constructor(
    protected dialog: MatDialog, protected translate: TranslateService
  ) {
    super(dialog, translate);
  }

  defaultFileUploadFormConfigs: FileUploadFormConfigs = {
    uploadPath: 'upload/csv',
    uploadParams: null,
    dialogTitle: this.translate.instant("fileUploadForm.bulkUpload"),
    downloadTemplateTitle: this.translate.instant("fileUploadForm.downloadTemplate"),
    downloadTemplatePlaceholder: this.translate.instant("fileUploadForm.downloadTemplatePlaceholder"),
    uploaderExtensions: 'CSV, XLS, XLSX',
    uploaderFileType: 'csv',
    uploaderFormControlName: 'file',
    uploaderLabelInput: this.translate.instant("fileUploadForm.documentsNeeded"),
    returnAsFile: false,
    uploaderShowProgress: true,
    submitButtonLabel: this.translate.instant("fileUploadForm.submit"),
    uploaderFileSize: 5,
  }

  openFileUploadForm(
    apiUrl: string,
    templateHref?: string,
    configurations?: FileUploadFormConfigs
  ): Observable<boolean> {
    const data = {apiUrl: apiUrl, templateHref: templateHref, ...this.defaultFileUploadFormConfigs, ...configurations};
    return this.openDialog(FileUploadFormComponent, {data: data});
  }
}
